import { Vector3 } from 'three'
import { get } from './fetchData'
import urls from './trackers'
import { LATI_TRANS, LONG_TRANS } from '~shared/NetworkVisualizer'
import { Y_POS } from '~shared/NetworkVisualizer/Particles'

export default async function feed() {
    const coordinates = []

    const metadata = new WeakMap()

    const nodeCoordinates = {}

    await Promise.all(urls.map(async (trackerURL) => {
        const collection = await (async () => {
            try {
                return await get(`${trackerURL}/location/`)
            } catch (e) {
                console.warn(`Failed to load node details from "${trackerURL}"`)
            }

            return {}
        })()

        Object.entries(collection).forEach(([nodeId, { latitude, longitude, country }]) => {
            const v3 = new Vector3(longitude * LONG_TRANS, Y_POS, -latitude * LATI_TRANS)

            const hit = coordinates.find((v) => v3.distanceToSquared(v) < 0.0005)

            if (!hit) {
                coordinates.push(v3)
                metadata.set(v3, {
                    country,
                    latitude,
                    longitude,
                    nodeId,
                    trackerURL,
                })
            }

            nodeCoordinates[nodeId] = hit || v3
        })
    }))

    return {
        coordinates,
        metadata,
        nodeCoordinates,
    }
}
